// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/capture_solution_reviews.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.CaptureSolutionEvidenceDecision
 */ export class CaptureSolutionEvidenceDecision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionEvidenceDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionEvidenceDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionEvidenceDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionEvidenceDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * adopted | dismissed | deferred
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string proposed_text = 4;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 6;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string result_revision_id = 7;
   */ _define_property(this, "resultRevisionId", ""), /**
   * @generated from field: string request_id = 8;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionEvidenceDecision, "runtime", proto3);
_define_property(CaptureSolutionEvidenceDecision, "typeName", "mono.datagateway.v1.CaptureSolutionEvidenceDecision");
_define_property(CaptureSolutionEvidenceDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "result_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureSolutionReview
 */ export class CaptureSolutionReview extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 3;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string base_revision_id = 4;
   */ _define_property(this, "baseRevisionId", ""), /**
   * @generated from field: string refreshed_from_id = 5;
   */ _define_property(this, "refreshedFromId", ""), /**
   * @generated from field: string target_kind = 6;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 7;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string target_field = 8;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string target_label = 9;
   */ _define_property(this, "targetLabel", ""), /**
   * Snapshot at base_revision_id, not necessarily current head.
   *
   * @generated from field: string current_position = 10;
   */ _define_property(this, "currentPosition", ""), /**
   * needs_review | unavailable | no_changes; never a proven material impact.
   *
   * @generated from field: string impact_state = 11;
   */ _define_property(this, "impactState", ""), /**
   * @generated from field: string source_version_id = 12;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string prior_source_version_id = 13;
   */ _define_property(this, "priorSourceVersionId", ""), /**
   * @generated from field: string artifact_id = 14;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 15;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string sha256 = 16;
   */ _define_property(this, "sha256", ""), /**
   * @generated from field: string source_kind = 17;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_label = 18;
   */ _define_property(this, "sourceLabel", ""), /**
   * Protected original text whose downloaded bytes match this exact version/SHA.
   *
   * @generated from field: string evidence_text = 19;
   */ _define_property(this, "evidenceText", ""), /**
   * text | non_text | unavailable; no internal error details.
   *
   * @generated from field: string evidence_state = 20;
   */ _define_property(this, "evidenceState", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureSolutionEvidenceDecision decisions = 21;
   */ _define_property(this, "decisions", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionReview, "runtime", proto3);
_define_property(CaptureSolutionReview, "typeName", "mono.datagateway.v1.CaptureSolutionReview");
_define_property(CaptureSolutionReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "refreshed_from_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "target_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "current_position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "impact_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "prior_source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "evidence_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "evidence_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "decisions",
            kind: "message",
            T: CaptureSolutionEvidenceDecision,
            repeated: true
        },
        {
            no: 22,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureSolutionReviewsRequest
 */ export class ListCaptureSolutionReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionReviewsRequest, "runtime", proto3);
_define_property(ListCaptureSolutionReviewsRequest, "typeName", "mono.datagateway.v1.ListCaptureSolutionReviewsRequest");
_define_property(ListCaptureSolutionReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureSolutionReviewsResponse
 */ export class ListCaptureSolutionReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureSolutionReview reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionReviewsResponse, "runtime", proto3);
_define_property(ListCaptureSolutionReviewsResponse, "typeName", "mono.datagateway.v1.ListCaptureSolutionReviewsResponse");
_define_property(ListCaptureSolutionReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: CaptureSolutionReview,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureSolutionReviewRequest
 */ export class GetCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(GetCaptureSolutionReviewRequest, "typeName", "mono.datagateway.v1.GetCaptureSolutionReviewRequest");
_define_property(GetCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureSolutionReviewResponse
 */ export class GetCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(GetCaptureSolutionReviewResponse, "typeName", "mono.datagateway.v1.GetCaptureSolutionReviewResponse");
_define_property(GetCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureSolutionReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideCaptureSolutionReviewRequest
 */ export class DecideCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * adopted | dismissed | deferred
   *
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * Manual authoring; assumptions field takes a JSON string array.
   *
   * @generated from field: string proposed_text = 7;
   */ _define_property(this, "proposedText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(DecideCaptureSolutionReviewRequest, "typeName", "mono.datagateway.v1.DecideCaptureSolutionReviewRequest");
_define_property(DecideCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideCaptureSolutionReviewResponse
 */ export class DecideCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionEvidenceDecision decision = 1;
   */ _define_property(this, "decision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(DecideCaptureSolutionReviewResponse, "typeName", "mono.datagateway.v1.DecideCaptureSolutionReviewResponse");
_define_property(DecideCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: CaptureSolutionEvidenceDecision
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RefreshCaptureSolutionReviewRequest
 */ export class RefreshCaptureSolutionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCaptureSolutionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCaptureSolutionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCaptureSolutionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCaptureSolutionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: int64 expected_revision = 3;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCaptureSolutionReviewRequest, "runtime", proto3);
_define_property(RefreshCaptureSolutionReviewRequest, "typeName", "mono.datagateway.v1.RefreshCaptureSolutionReviewRequest");
_define_property(RefreshCaptureSolutionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RefreshCaptureSolutionReviewResponse
 */ export class RefreshCaptureSolutionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCaptureSolutionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCaptureSolutionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCaptureSolutionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCaptureSolutionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureSolutionReview review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCaptureSolutionReviewResponse, "runtime", proto3);
_define_property(RefreshCaptureSolutionReviewResponse, "typeName", "mono.datagateway.v1.RefreshCaptureSolutionReviewResponse");
_define_property(RefreshCaptureSolutionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureSolutionReview
        }
    ]));
